import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FilePreviewModel } from '../../models/file-preview-model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslationService } from '../../../../services';
import { TranslationResolver } from '../../../../helpers/translation-resolver';
import { FileResponse, NavigationService } from '../../../../modules/tcm-core.module';
import { InterpolatableTranslationObject } from '@ngx-translate/core';

@Component({
    selector: 'tcm-file-preview',
    templateUrl: './file-preview.component.html',
    styleUrls: ['./file-preview.component.scss'],
    standalone: false
})
export class FilePreviewComponent implements OnInit, OnDestroy {

  // @Input() titleKey: TranslationResolver;
  @Input() titleKey: any;

  @Input() model: any;

  title: string;

  isLoading: boolean;

  url: SafeResourceUrl;

  mimeType: string;

  private resourceUrl: string;

  @ViewChild('objectContainer', {read: ElementRef, static: true}) 
  private objectContainer: ElementRef<HTMLElement>;

  constructor(private nav: NavigationService, private translator: TranslationService) { 

  }

  async ngOnInit() {

    this.title = this.translator.translate(this.titleKey || (x => x.Messages.MessageHeadersAndActions.Preview));

    try{
      this.isLoading = true;

      let blob: Blob;
      
    // here was this.model instanceof FileResponse when testing check if causes a problem to set it up as any
      if(this.model.constructor.name === 'FileResponse'){
        let model: FileResponse = this.model;
        blob = await this.model.toBlobAsync();
        this.mimeType = model.mimeType;
      }
      else{
        let model: FilePreviewModel = this.model;
        blob = this.model.blob;
        this.mimeType = this.model.mimeType;
      }
  
      this.resourceUrl = URL.createObjectURL(blob);

      this.appendObjectTag();
    }
    finally {
      this.isLoading = false;
    }
  }

  ngOnDestroy(): void {
    if(this.url) {
      URL.revokeObjectURL(this.resourceUrl);
    }
  }

  download() {
    // here was this.model instanceof FileResponse
    if(this.model) {
      this.model.save();
    }
  }

  back() {
    this.nav.navigateBack();
  }

  private appendObjectTag() {

      const objectElement = document.createElement('object');
      const iframeElement = document.createElement('iframe');
      objectElement.appendChild(iframeElement);

      objectElement.type = this.mimeType;
      objectElement.data = this.resourceUrl;
      objectElement.style.flex = "1";

      iframeElement.src = this.resourceUrl;

      this.objectContainer.nativeElement.parentElement.appendChild(objectElement);      
  }
}
